export const userPermissions = [
  // general
  "VIEW_ACCOUNT_BALANCE",
  "VIEW_ASSET",

  // deposit addresses
  "VIEW_DEPOSIT_ADDRESSES",
  "REQUEST_DEPOSIT_ADDRESS",

  // withdrawal addresses
  "VIEW_WITHDRAWAL_ADDRESS",
  "CREATE_WITHDRAWAL_ADDRESS",

  // withdrawals
  "REQUEST_WITHDRAWAL",

  // transactions
  "VIEW_LEDGER_ENTRIES",

  // transfers
  "REQUEST_TRANSFER",

  // policy engine
  "VIEW_POLICY",
  "VIEW_APPROVALS",

  //beneficiaries
  "MANAGE_CLIENT_PERSONAL_INFORMATION",

  // kiosk settings
  "VIEW_HOSTED_DEPOSIT_SETTINGS",
];
